import React from 'react';

/** Relo yellow — same as Resource Center “relo” logo badge. */
const LOGO_YELLOW = '#ffd100';
/** Black question mark — same as logo text. */
const LOGO_BLACK = '#000';

/** Help icon: yellow circle + black question mark (2rem = 32px). */
export const HelpIcon = ({ size = 32 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="32 32 960 960"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <circle
            cx="512"
            cy="512"
            r="448"
            fill={LOGO_YELLOW}
        />
        <path
            fill={LOGO_BLACK}
            d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
        />
    </svg>
);
